import React, { useEffect, useState } from 'react';
import './Notification.css';

const Notification = ({ message, type = 'info', onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Component fades in and stays for 5 seconds before fading out
    const timer = setTimeout(() => {
      setVisible(false);
      onClose();  // Trigger any additional cleanup or state updates needed on close
    }, 6000); // Total animation time is 6 seconds to allow 1 second for fade out

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!visible) return null;

  return (
    <div className={`notification ${type}`} role="alert" aria-live="assertive">
      {message}
      {/* <button onClick={() => { setVisible(false); onClose(); }} className="close-button">X</button> */}
    </div>
  );
};

export default Notification;
